export const GET_SINGLE_ITEM = "GET_SINGLE_ITEM";
export const GET_ALL_ITEMS_POPULAR = "GET_ALL_ITEMS_POPULAR";
export const GET_ALL_POPULAR_ITEMS = "GET_ALL_POPULAR_ITEMS";
export const GET_SEARCH_SINGLE_ITEMS = "GET_SEARCH_SINGLE_ITEMS";